import { render } from "./SubLevelElectionConsolidatedReport.vue?vue&type=template&id=5619892d&scoped=true"
import script from "./SubLevelElectionConsolidatedReport.vue?vue&type=script&lang=js"
export * from "./SubLevelElectionConsolidatedReport.vue?vue&type=script&lang=js"

import "./SubLevelElectionConsolidatedReport.vue?vue&type=style&index=0&id=5619892d&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5619892d"]])

export default __exports__